import React, {Component} from 'react';
import { DatePicker } from 'antd';
import {Row, Col, Modal} from 'react-bootstrap';
import swal from 'sweetalert2';
import moment from 'moment';
import {BootstrapTable, TableHeaderColumn, ButtonGroup, ExportCSVButton} from 'react-bootstrap-table';
import Autosuggest from 'react-autosuggest';

import "sweetalert2/dist/sweetalert2.min.css";
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import AddPayment from './AddPayment';

function getSuggestionValue(suggestion) {
  return suggestion.name;
}

function renderSuggestion(suggestion) {
  return (
    <div className="suggestion-container">
  		<div className="org-logo" style={suggestion.logo ? {backgroundImage: 'url(' + process.env.REACT_APP_ASSETS_URL + suggestion.logo + ')'} : null}></div>
  		{suggestion.name}
  	</div>
  );
}

export default class ManagePayments extends Component {
	constructor(props) {
		super(props);
		this.state = {
			paymentDetails: null,
			addPaymentFormVisible: false,
			addPaymentLoader: false,
			showTxnError: false,
			showDateError: false,
			showAmountError: false,
			showRenewalError: false,
			showPeriodError: false,
			showModeError: false,
			showPOCError: false,
			newPayment: {
				txn_id: '',
				invoice_id: '',
				invoice: null,
				payment_date: null,
				amount: '',
				offer: '',
				is_renewal: false,
				paid_for: '',
				mode: '',
				extras: {
					poc: ''
				}
			},
			mergePaymentModalVisible: false,
			selected_payment: null,
			value: '',
			suggestions: [],
      isLoading: false,
      selectedOrg: null,
      selectedWebsite: null,
      showSelectedOrgError: false,
			showSelectedWebsiteError: false,
			editPaymentModalVisible: false
		};
		this.getPaymentDetails = this.getPaymentDetails.bind(this);
		this.lastRequestId = null;
	}

	componentDidMount() {
		this.getPaymentDetails(this);
	}

	showAddPaymentForm() {
		this.setState({ addPaymentFormVisible: true });
	}

	getPaymentDetails() {
  	fetch(process.env.REACT_APP_API_URL + '/swayam/payments', {
  	  method: 'GET',
  	  headers: {
  	    'Auth': this.props.access_token
	  	},
  	}).then((response) => response.json())
  	.then((data) => {
  		if(data.status === 'success') {
				this.setState({ paymentDetails: data.data });
		  }
	  });
	}

	resetAddPaymentForm() {
		this.setState({
			addPaymentFormVisible: false,
			addPaymentLoader: false,
			newPayment: {
				txn_id: '',
				invoice_id: '',
				invoice: null,
				payment_date: null,
				amount: '',
				offer: '',
				is_renewal: false,
				paid_for: '',
				mode: '',
				extras: {
					poc: ''
				}
			},
			showTxnError: false,
			showDateError: false,
			showAmountError: false,
			showRenewalError: false,
			showPeriodError: false,
			showModeError: false,
			showPOCError: false
		});
	}

	addNewPayment() {
		let newPayment = this.state.newPayment;
		if(newPayment.txn_id !== '' && newPayment.payment_date !== null && newPayment.amount !== '' && newPayment.is_renewal !== null && newPayment.paid_for !== '' && newPayment.mode !== '' && newPayment.extras.poc !== '') {
			this.setState({ addPaymentLoader: true });

			let data = new FormData();
			data.append('txn_id', newPayment.txn_id);
			if(newPayment.invoice !== null) data.append('invoice', newPayment.invoice[0]);
			data.append('invoice_id', newPayment.invoice_id);
			data.append('payment_date', moment(newPayment.payment_date).format('YYYY-MM-DD'));
			data.append('amount', newPayment.amount);
			data.append('offer', newPayment.offer);
			data.append('is_renewal', newPayment.is_renewal);
			data.append('paid_for', newPayment.paid_for);
			data.append('mode', newPayment.mode);
			data.append('extras', JSON.stringify(newPayment.extras));

	  	fetch(process.env.REACT_APP_API_URL + '/swayam/payments', {
	  	  method: 'POST',
	  	  headers: {
	  	    'Auth': this.props.access_token
  	  	},
	  	  body: data
	  	}).then((response) => response.json())
	  	.then((data) => {
	  		if(data.status === 'success') {
	  			this.resetAddPaymentForm(this);
			  	swal({
			  	  title: "Saved!",
			  	  html: "<h4>Successfully added new payment!</h4>",
			  	  type: "success"
			  	});
			  	this.getPaymentDetails(this);
			  }
		  });
	  } else {
	  	if(newPayment.txn_id === '') this.setState({ showTxnError: true });
	  	if(newPayment.payment_date === null) this.setState({ showDateError: true });
	  	if(newPayment.amount === '') this.setState({ showAmountError: true });
	  	if(newPayment.is_renewal === null) this.setState({ showRenewalError: true });
	  	if(newPayment.paid_for === '') this.setState({ showPeriodError: true });
	  	if(newPayment.mode === '') this.setState({ showModeError: true });
	  	if(newPayment.extras.poc === '') this.setState({ showPOCError: true });
	  }
	}

	handleChange(name, event) {
		let newPayment = this.state.newPayment;
		if(name === 'payment_date') newPayment[name] = event;
		else if(name === 'invoice') newPayment[name] = event.target.files;
		else if(name === 'poc') newPayment['extras']['poc'] = event.target.value;
		else newPayment[name] = event.target.value;
		if(name === 'txn_id') this.setState({ showTxnError: false });
		else if(name === 'payment_date') this.setState({ showDateError: false });
		else if(name === 'amount') this.setState({ showAmountError: false });
		else if(name === 'is_renewal') this.setState({ showRenewalError: false });
		else if(name === 'paid_for') this.setState({ showPeriodError: false });
		else if(name === 'mode') this.setState({ showModeError: false });
		else if(name === 'poc') this.setState({ showPOCError: false });
		this.setState({ newPayment });
	}

	isRenewal(cell, row) {
		if(!cell) return 'No';
		else return 'Yes';
	}

	invoiceId(cell, row) {
		if(cell !== null && cell !== '') {
			return (
				<a className="le-link" href={row.invoiceUrl} target="_blank">{cell}</a>
			)
		} else return '';
	}

	mergePaymentFormatter(cell, row) {
		return (
			<button className="btn merge-payment-button" onClick={this.mergePayment.bind(this, row.id)}>Merge</button>
		)
	}

	mergePayment(payment_id) {
		this.setState({ mergePaymentModalVisible: true, selected_payment: payment_id, selectedOrg: null, selectedWebsite: null });
	}

	hideMergePaymentModal() {
		this.setState({
			mergePaymentModalVisible: false,
			selected_payment: null,
			selectedOrg: null,
			selectedWebsite: null,
			showSelectedOrgError: false,
			showSelectedWebsiteError: false
		});
	}

	loadSuggestions(value) {
    // Cancel the previous request
    if (this.lastRequestId !== null) {
      clearTimeout(this.lastRequestId);
    }

    this.setState({ selectedOrg: null, selectedWebsite: null });

    if(value !== '' && value.length > 2) {
    	this.setState({ isLoading: true });
    	let query = '?name=' + value;
	    fetch(process.env.REACT_APP_API_URL + '/orgs/search' + query, {
	  	  method: 'GET',
	  	  headers: {
	  	    'Auth': this.props.access_token
  	  	},
	  	}).then((response) => response.json())
	  	.then((data) => {
	  		if(data.status === 'success') {
	  			console.log(data)
		      this.setState({
		        isLoading: false,
		        suggestions: data.data.orgs
		      });
			  }
		  });
	  }
  }

  onChange = (event, { newValue }) => {
    this.setState({ value: newValue });
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.loadSuggestions(value);
  }

  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] });
  }

  onSuggestionSelected(event, selected) {
  	this.setState({ selectedOrg: selected.suggestion, showSelectedOrgError: false });
  }

  changeSelectedWebsite(website_id) {
  	this.setState({ selectedWebsite: website_id, showSelectedWebsiteError: false });
  }

  saveMergePayment() {
  	if(this.state.selectedOrg !== null && this.state.selectedWebsite !== null) {
	  	swal({
	  	  title: 'Are you sure?',
	  	  text: "You won't be able to revert this!",
	  	  type: 'warning',
	  	  showCancelButton: true,
	  	  confirmButtonText: 'Yes, Save!',
	  	  cancelButtonText: 'No, Cancel!',
	  	  confirmButtonClass: 'btn',
	  	  cancelButtonClass: 'btn',
	  	}).then(function (result) {
	  	  if(result) {
	  	  	let data = new FormData();
	  	  	data.append('org_id', this.state.selectedOrg.id);
	  	  	data.append('website_id', this.state.selectedWebsite);
	  	  	fetch(process.env.REACT_APP_API_URL + '/swayam/payments/' + this.state.selected_payment, {
	  	  	  method: 'PUT',
	  	  	  headers: {
			  	    'Auth': this.props.access_token
		  	  	},
	  	  	  body: data
	  	  	}).then((response) => response.json())
	  	  	.then((data) => {
	  	  		if(data.status === 'success') {
	  					this.getPaymentDetails(this);
	  					this.hideMergePaymentModal(this);
	  			  }
	  		  });
	  	  }
	  	}.bind(this));
	  } else {
	  	if(this.state.selectedOrg === null) this.setState({ showSelectedOrgError: true });
	  	if(this.state.selectedWebsite === null) this.setState({ showSelectedWebsiteError: true });
	  }
  }

  editPaymentFormatter(cell, row) {
  	return (
  		<button className="btn edit-payment-button" onClick={this.editPayment.bind(this, row)}><i className="fa fa-pencil"></i></button>
  	)
  }

  pocFormatter(cell, row) {
  	if(row.hasOwnProperty('extras') && row.extras.hasOwnProperty('poc') && row.extras.poc) {
	  	return (
	  		<span>{row.extras.poc}</span>
	  	)
	  } else return '';
  }

  editPayment(payment) {
  	let newPayment = {};
  	newPayment['txn_id'] = payment['txnId'];
  	newPayment['invoice_id'] = payment['invoiceId'] || '';
  	newPayment['invoice_url'] = payment['invoiceUrl'] || '';
  	newPayment['payment_date'] = moment(payment['paymentDate'], 'DD/MM/YYYY');
  	newPayment['amount'] = payment['amount'];
  	newPayment['offer'] = payment['offer'];
  	newPayment['is_renewal'] = payment['isRenewal'];
  	newPayment['paid_for'] = payment['paidFor'];
  	newPayment['mode'] = payment['mode'];
  	newPayment['extras'] = payment['extras'];
  	this.setState({ newPayment, editPaymentModalVisible: true, selected_payment: payment.id });
  }

  hideEditPaymentModal() {
  	this.setState({
  		editPaymentModalVisible: false,
  		addPaymentLoader: false,
  		newPayment: {
  			txn_id: '',
  			invoice_id: '',
  			invoice: null,
  			payment_date: null,
  			amount: '',
  			offer: '',
  			is_renewal: false,
  			paid_for: '',
  			mode: '',
  			extras: {
  				poc: ''
  			}
  		},
  		selected_payment: null,
  		showTxnError: false,
  		showDateError: false,
  		showAmountError: false,
  		showRenewalError: false,
  		showPeriodError: false,
  		showModeError: false,
  		showPOCError: false
  	});
  }

  updatePayment() {
		let newPayment = this.state.newPayment;
		if(newPayment.txn_id !== '' && newPayment.payment_date !== null && newPayment.amount !== '' && newPayment.is_renewal !== null && newPayment.paid_for !== '' && newPayment.mode !== '') {
			this.setState({ addPaymentLoader: true });

			let data = new FormData();
			data.append('txn_id', newPayment.txn_id);
			if(newPayment.invoice !== null && newPayment.invoice !== undefined) data.append('invoice', newPayment.invoice[0]);
			data.append('invoice_id', newPayment.invoice_id);
			data.append('payment_date', moment(newPayment.payment_date).format('YYYY-MM-DD'));
			data.append('amount', newPayment.amount);
			data.append('offer', newPayment.offer);
			data.append('is_renewal', newPayment.is_renewal);
			data.append('paid_for', newPayment.paid_for);
			data.append('mode', newPayment.mode);
			data.append('extras', JSON.stringify(newPayment.extras));

	  	fetch(process.env.REACT_APP_API_URL + '/swayam/payments/' + this.state.selected_payment, {
	  	  method: 'PUT',
	  	  headers: {
	  	    'Auth': this.props.access_token
  	  	},
	  	  body: data
	  	}).then((response) => response.json())
	  	.then((data) => {
	  		if(data.status === 'success') {
	  			this.hideEditPaymentModal(this);
			  	swal({
			  	  title: "Saved!",
			  	  html: "<h4>Successfully added new payment!</h4>",
			  	  type: "success"
			  	});
			  	this.getPaymentDetails(this);
			  }
		  });
	  } else {
	  	if(newPayment.txn_id === '') this.setState({ showTxnError: true });
	  	if(newPayment.payment_date === null) this.setState({ showDateError: true });
	  	if(newPayment.amount === '') this.setState({ showAmountError: true });
	  	if(newPayment.is_renewal === null) this.setState({ showRenewalError: true });
	  	if(newPayment.paid_for === '') this.setState({ showPeriodError: true });
	  	if(newPayment.mode === '') this.setState({ showModeError: true });
	  	if(newPayment.extras.poc === '') this.setState({ showPOCError: true });
	  }
  }

	render() {
		const paymentTableOptions = {
			sizePerPageList: [
			  { text: '20 Per Page', value: 20 },
			  { text: '50 Per Page', value: 50 },
			  { text: '100 Per Page', value: 100 }
			],
		}

		const { value, suggestions, isLoading } = this.state;
    const inputProps = {
      placeholder: "Select Organisation",
      value,
      onChange: this.onChange
    };
    const status = (isLoading ? 'Loading...' : 'Type to load suggestions');

		return (
			<div className="page-container manage-payments-page">
				{this.state.paymentDetails !== null ? (
					<div className="payment-details-container">
						<div className="payment-details-header">
							<h3>Payment Details</h3>
							<div className="buttons-container">
								<button className="btn btn-success add-payment-button"
									onClick={this.showAddPaymentForm.bind(this)}>
									<i className="fa fa-plus"></i> Add Payment
								</button>
							</div>
						</div>

						{this.state.addPaymentFormVisible ? (
							<div className="add-payment-form-container">
								<AddPayment website_id={null} newPayment={this.state.newPayment} showModeError={this.state.showModeError}
									addNewPayment={this.addNewPayment.bind(this)} resetAddPaymentForm={this.resetAddPaymentForm.bind(this)}
									showInvoiceError={this.state.showInvoiceError} showInvoiceUrlError={this.state.showInvoiceUrlError}
									showRenewalError={this.state.showRenewalError} showPeriodError={this.state.showPeriodError}
									showDateError={this.state.showDateError} showAmountError={this.state.showAmountError}
									showTxnError={this.state.showTxnError} handleChange={this.handleChange.bind(this)}
									addPaymentLoader={this.state.addPaymentLoader} />
							</div>
						) : (null)}

						<div className="payment-details-table-container">
							<BootstrapTable data={this.state.paymentDetails} options={paymentTableOptions} className="payment-details-table"
							  striped={false} hover={true} ref='table' csvFileName={'Payments - ' + String(moment().unix()) + '.csv'} keyField='id'
							  exportCSV search searchPlaceholder="Search by TxnId/InvoiceId/Amount/Date">
							  <TableHeaderColumn dataField="id" 												hidden={true}  export={false} searchable={false}>Id</TableHeaderColumn>
							  <TableHeaderColumn dataField="txnId" 			 width='100px' dataSort={true} hidden={false} export={true}  searchable={true}  columnTitle>Transaction Id</TableHeaderColumn>
							  <TableHeaderColumn dataField="invoiceId"   width='100px' dataSort={true} hidden={false} export={true}  searchable={true}  dataFormat={this.invoiceId}>Invoice Id</TableHeaderColumn>
							  <TableHeaderColumn dataField="invoiceUrl"   						 dataSort={true} hidden={true}  export={true}  searchable={true}  columnTitle>Invoice Url</TableHeaderColumn>
							  <TableHeaderColumn dataField="paymentDate" width='120px' dataSort={true} hidden={false} export={true}  searchable={false} columnTitle>Payment Date</TableHeaderColumn>
							  <TableHeaderColumn dataField="amount"      width='100px' dataSort={true} hidden={false} export={true}  searchable={true}  columnTitle>Amount (₹)</TableHeaderColumn>
							  <TableHeaderColumn dataField="offer"       width='80px'  dataSort={true} hidden={false} export={true}  searchable={false} columnTitle>Offer</TableHeaderColumn>
							  <TableHeaderColumn dataField="isRenewal" 	 width='80px'  dataSort={true} hidden={false} export={true}  searchable={false} columnTitle dataFormat={this.isRenewal}>Is Renewal</TableHeaderColumn>
							  <TableHeaderColumn dataField="paidFor"     width='100px' dataSort={true} hidden={false} export={true}  searchable={true}  columnTitle>Payment Period</TableHeaderColumn>
							  <TableHeaderColumn dataField="mode"      	 width='100px' dataSort={true} hidden={false} export={true}  searchable={true}  columnTitle>Mode Of Payment</TableHeaderColumn>
							  <TableHeaderColumn dataField="poc"      	 width='80px'  dataSort={true} hidden={false} export={true}  searchable={true}  dataFormat={this.pocFormatter.bind(this)}>POC</TableHeaderColumn>
							  <TableHeaderColumn dataField="mode" 			 width='75px' dataSort={false} hidden={false} export={false} searchable={false} dataFormat={this.mergePaymentFormatter.bind(this)}>Add To ORG</TableHeaderColumn>
							  <TableHeaderColumn dataField="mode" 			 width='52px' dataSort={false} hidden={false} export={false} searchable={false} dataFormat={this.editPaymentFormatter.bind(this)}>Edit</TableHeaderColumn>
							</BootstrapTable>
						</div>

						{this.state.editPaymentModalVisible ? (
							<Modal className="edit-payment-modal" show={this.state.editPaymentModalVisible}
							  onHide={this.hideEditPaymentModal.bind(this)} bsSize="large">
							  <Modal.Header>
							    <Modal.Title className="modal-header-custom">
							      Edit Payment
							    </Modal.Title>
							  </Modal.Header>
							  <Modal.Body>
							    <Row>
						    		<Col className="edit-payment-container add-payment-form-container" md={12}>
					    				<AddPayment type='edit' website_id={null} newPayment={this.state.newPayment} showModeError={this.state.showModeError}
					    					addNewPayment={this.updatePayment.bind(this)} resetAddPaymentForm={this.hideEditPaymentModal.bind(this)}
					    					showInvoiceError={this.state.showInvoiceError} showInvoiceUrlError={this.state.showInvoiceUrlError}
					    					showRenewalError={this.state.showRenewalError} showPeriodError={this.state.showPeriodError}
					    					showDateError={this.state.showDateError} showAmountError={this.state.showAmountError}
					    					showTxnError={this.state.showTxnError} handleChange={this.handleChange.bind(this)}
					    					addPaymentLoader={this.state.addPaymentLoader} />
						    		</Col>
						    	</Row>
						    </Modal.Body>
						  </Modal>
						) : (null)}

						{this.state.selected_payment !== null && this.state.mergePaymentModalVisible ? (
							<Modal className="merge-payments-modal" show={this.state.mergePaymentModalVisible}
							  onHide={this.hideMergePaymentModal.bind(this)} bsSize="large">
							  <Modal.Header>
							    <Modal.Title className="modal-header-custom">
							      Add Payment To Website
							    </Modal.Title>
							  </Modal.Header>
							  <Modal.Body>
							    <Row>
						    		<Col className="merge-payments-container" md={12}>
						    			<Col className="merge-payments-ngo-select-container" md={6}>
						    				<label className="control-label is-imp">Select Organisation: </label>
							    			<Autosuggest suggestions={suggestions} onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
				                  getSuggestionValue={getSuggestionValue} onSuggestionSelected={this.onSuggestionSelected.bind(this)}
				                  onSuggestionsClearRequested={this.onSuggestionsClearRequested}
				                  renderSuggestion={renderSuggestion} inputProps={inputProps} />
				                <span hidden={!this.state.showSelectedOrgError}><span className="required-span">Please select a valid Organisation.</span></span>
				              </Col>

				              {this.state.selectedOrg !== null ? (
				              	<Col md={12}>
					              	<label className="control-label is-imp">Select Website: </label>
					              	<Row className="merge-payments-website-select-container">
					              		{this.state.selectedOrg.websites.map(function(website, index) {
					              			return (
					              				<div key={index} className="website-container">
					              					<label className="label-container">{'Website: ' + website.publishUrl}
					              					  <input type="radio" name="merge-payments-website"
					              					  	checked={website.id === this.state.selectedWebsite}
					              					  	onChange={this.changeSelectedWebsite.bind(this, website.id)} />
					              					  <span className="checkmark"></span>
					              					</label>
					              				</div>
					              			)
					              		}.bind(this))}
					              	</Row>
					              	<span hidden={!this.state.showSelectedWebsiteError}><span className="required-span">Please select a valid Website.</span></span>
					              </Col>
				              ): (null)}

				              <Col md={12} className="merge-payments-buttons-container mt20">
				              	<button className="btn merge-payments-save-button" onClick={this.saveMergePayment.bind(this)}>Save</button>
				              	<button className="btn merge-payments-cancel-button" onClick={this.hideMergePaymentModal.bind(this)}>Cancel</button>
				              </Col>
							    	</Col>
							    </Row>
							  </Modal.Body>
							</Modal>
						) : (null)}
					</div>
				) : (null)}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/ManagePayments/ManagePayments.js